const acceptable_types = [
  "PDF",
  "JPG",
  "PNG",
  "DOC",
  "XLS",
  "PPT",
  "TXT",
  "MSG",
] as const

type AcceptableType = (typeof acceptable_types)[number]

type AcceptableTypeConfigItem = {
  description: string
  specifiers: string[]
}

const configuration: Record<AcceptableType, AcceptableTypeConfigItem> = {
  PDF: {
    description: ".pdf",
    specifiers: [".pdf", "application/pdf"],
  },
  JPG: {
    description: ".jpg .jpeg",
    specifiers: [".jpg", "image/jpg", ".jpeg", "image/jpeg"],
  },
  PNG: {
    description: ".png",
    specifiers: [".png", "image/png"],
  },
  DOC: {
    description: ".doc .docx",
    specifiers: [
      ".doc",
      "application/msword",
      ".docx",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ],
  },
  XLS: {
    description: ".xls .xlsx",
    specifiers: [
      ".xls",
      "application/vnd.ms-excel",
      ".xlsx",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ],
  },
  PPT: {
    description: ".ppt .pptx",
    specifiers: [
      ".ppt",
      "application/vnd.ms-powerpoint",
      ".pptx",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    ],
  },
  TXT: {
    description: ".txt",
    specifiers: [".txt", "text/plain"],
  },

  MSG: /* Microsoft Outlook */ {
    description: ".msg",
    specifiers: [".msg"],
  },
}

/**
 * Use this function to get the value for the accept attribute of
 * <input type="file">, useDropzone hook, etc...
 * filetypes defaults to all acceptable types defined above
 */
export function getAcceptableFiles(filetypes?: AcceptableType[]) {
  const fts = filetypes || acceptable_types
  let descriptions: string[] = []
  let specifiers: string[] = []

  fts.forEach((it) => {
    const x = configuration[it]
    descriptions.push(x.description)
    specifiers.push(...x.specifiers)
  })

  return { accept: specifiers.slice(), description: descriptions.join(" ") }
}

export const allAcceptableFilesPhrase = getAcceptableFiles().description
